import { Text } from '@user-portal/wikr-components';

import { Button } from 'components/Buttons/OverlineButton/styled';

const OverlineButton = ({
    text,
    onClick,
    mb,
    dataLocator,
}: {
    text: string;
    onClick: () => void;
    mb?: string | number;
    dataLocator?: string;
}) => (
    <Button onClick={onClick} mb={mb} data-locator={dataLocator}>
        <Text type="overline">{text}</Text>
    </Button>
);

export default OverlineButton;
